'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var anatomy = require('@chakra-ui/anatomy');

/*
 * Contains all component anatomies.
 * @see https://github.com/chakra-ui/chakra-ui/blob/95aa4499c72de28e91dd9274177c529db55e7964/packages/components/anatomy/src/components.ts
 */

/**
 * **Date field anatomy**
 * - Root: the root container and virtual field of the date field
 * - Segment: a single segment of the date field
 */
var dateFieldAnatomy = anatomy.anatomy('dateField').parts('root', 'segment');

/**
 * **Time field anatomy**
 * - Root: the root container and virtual field of the time field
 * - Segment: a single segment of the time field
 */
var timeFieldAnatomy = anatomy.anatomy('timeField').parts('root', 'segment');
exports.dateFieldAnatomy = dateFieldAnatomy;
exports.timeFieldAnatomy = timeFieldAnatomy;